import { Builder } from '@builder.io/react';

import ComparisonTable from './index';

Builder.registerComponent(ComparisonTable, {
  name: 'ComparisonTable',
  inputs: [
    { name: 'headers', type: 'list', subFields: [{ name: 'text', type: 'string' }] },
    {
      name: 'sections',
      type: 'list',
      subFields: [
        { name: 'name', type: 'string' },
        {
          name: 'color',
          type: 'string',
          enum: ['scale-lightskyblue', 'scale-skyblue', 'scale-mauve', 'scale-lightmauve']
        },
        {
          name: 'rows',
          type: 'list',
          subFields: [
            {
              name: 'cells',
              type: 'list',
              subFields: [
                {
                  name: 'data',
                  type: 'string'
                }
              ]
            }
          ]
        }
      ]
    }
  ]
});
